<template>
  <RouterView />
</template>

<script setup lang="ts">
const { isLoggedIn } = useAuth()
const router = useRouter()

if (isLoggedIn.value) {
  router.push({ name: "home" })
}
</script>
